{
    "UI_Container_Title": "Account volledig instellen",
    "UI_Container_Description": "Voer je volledige naam en een wachtwoord in om de registratie te voltooien",
    "UI_Name_Placeholder": "Volledige naam",
    "UI_Name_Label": "Volledige naam",
    "UI_Password_Placeholder": "Wachtwoord",
    "UI_Password_Label": "Wachtwoord",
    "UI_PasswordLengthValidation": "Wachtwoord is te kort",
    "UI_PasswordRequiredValidation": "Wachtwoord mag niet leeg zijn",
    "UI_PasswordStrengthValidation": "Wachtwoord is niet sterk genoeg (hoofdletters, kleine letters en cijfers)",
    "UI_Footer_Server_Error": "Serverfout",
    "UI_Footer_Submit_Button": "Stuur  in",
    "UI_NameRequiredValidation": "Voer uw naam in",
    "NAME": "UserInvite"
}